// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editorBlock__RzxRN {
  width: 100%;
}

.editorLabel__HbeUQ {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  display: block;
  margin-bottom: 6px;
  padding-right: 17px;
}

.helperText__g07GS {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  color: var(--inputs-error-stroke);
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__g07GS {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.requiredMark__X8Vru:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-stroke);
  margin-left: 4px;
}`, "",{"version":3,"sources":["webpack://./../src/components/form/EditorForm/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AAzEF;AA2EE;EARF;IASI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAxEF;AACF;;AA4EE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,gBAAA;AAzEJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.editorBlock {\n  width: 100%;\n}\n\n.editorLabel {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  display: block;\n  margin-bottom: 6px;\n  padding-right: 17px;\n}\n\n.helperText {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--inputs-error-stroke);\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.requiredMark {\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-stroke);\n    margin-left: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editorBlock": `editorBlock__RzxRN`,
	"editorLabel": `editorLabel__HbeUQ`,
	"helperText": `helperText__g07GS`,
	"requiredMark": `requiredMark__X8Vru`
};
module.exports = ___CSS_LOADER_EXPORT___;
